(function ($) {
  $(document).ready(() => {
    const $container = $('.language-switcher');
    const $button = $('.language-switcher__button');
    const $curLang = $('.language-switcher__current');
    const $langList = $('.language-switcher__list');

    function languageSwitcherToggle() {
      $curLang.toggleClass('language-switcher__current--open');
      $langList.slideToggle();
    }

    $button.on('click tap', () => {
      languageSwitcherToggle();
    });

    if ($(window).width() > 992) {
      $button.on('mouseenter', () => {
        if ($curLang.hasClass('language-switcher__current--open')) {
          return;
        }
        languageSwitcherToggle();
      });

      $(document).on('mousemove', (event) => {
        if (!$container.is(event.target) && $container.has(event.target).length === 0 && $curLang.hasClass('language-switcher__current--open')) {
          languageSwitcherToggle();
        }
      });

      $(document).mouseup((event) => {
        if (!$container.is(event.target) && $container.has(event.target).length === 0 && $curLang.hasClass('language-switcher__current--open')) {
          languageSwitcherToggle();
        }
      });

      $(document).on('keydown', '.language-switcher__button', (event) => {
        if (event.keyCode === 13) {
          languageSwitcherToggle();
        }
      });

      $(document).on('keydown', '.language-switcher__item:last-child', (event) => {
        if (event.keyCode === 9) {
          setTimeout(() => { $button.focus(); }, 0);
        }
      });
    }
  });
}(jQuery));
